import { axiosInstance } from "../../Config/axiosConfig";
import endpoint from '../../Config/apiEndPointConstants';

export const getAIAssistantList = (authToken: string) => {
    return axiosInstance.get(endpoint.AIAGENT_LIST, {
        headers: {
            'x-access-token': authToken,
        },
    });
}

export interface CreateAIAssistantPayload {
    name: string;
    provider: string;
    ai_model: string;
    instructions: string;
    fallback_response: string;
    fallback_action: string;
    knowledgeBaseItems: any; // should be array or stringified JSON
    files?: File[];
    authToken: string;
    exit_after_time_in_minutes?: number;
    exit_after_no_of_responses?: number;
    exit_response?: string;
    exit_action?: string;
    humanize_response?: boolean;
    typing_speed?: number;
}

export const updateAIAssistant = (id: string, payload: CreateAIAssistantPayload, newFiles: File[]) => {
    const formData = new FormData();
    formData.append('name', payload.name);
    formData.append('provider', payload.provider);
    formData.append('ai_model', payload.ai_model);
    formData.append('instructions', payload.instructions);
    formData.append('fallback_response', payload.fallback_response);
    formData.append('fallback_action', payload.fallback_action);
    formData.append('exit_after_time_in_minutes', payload.exit_after_time_in_minutes ? payload.exit_after_time_in_minutes.toString() : '');
    formData.append('exit_after_no_of_responses', payload.exit_after_no_of_responses ? payload.exit_after_no_of_responses.toString() : '');
    formData.append('exit_response', payload.exit_response ? payload.exit_response : '');
    formData.append('exit_action', payload.exit_action ? payload.exit_action : '');
    formData.append('knowledgeBaseItems', typeof payload.knowledgeBaseItems === 'string' ? payload.knowledgeBaseItems : JSON.stringify(payload.knowledgeBaseItems));
    formData.append('humanize_response', payload.humanize_response ? 'true' : 'false');
    formData.append('typing_speed', payload.typing_speed ? payload.typing_speed.toString() : '');
    if (newFiles && Array.isArray(newFiles)) {
        newFiles.forEach(file => {
            formData.append('files[]', file);
        });
    }
    return axiosInstance.put(`${endpoint.AIAGENT_LIST}/${id}`, formData, {
        headers: {
            'x-access-token': payload.authToken,
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const deleteAIAgent = (id: string, authToken: string) => {
    return axiosInstance.delete(`${endpoint.AIAGENT_LIST}/${id}`, {
        headers: {
            'x-access-token': authToken,
        },
    });
};

export const interactWithAgent = (
    agentId: string,
    question: string,
    history: { role: string; content: string }[],
    authToken: string
) => {
    return axiosInstance.post(`${endpoint.AIAGENT_LIST}/interact/${agentId}`, { question, history }, {
        headers: {
            'x-access-token': authToken,
        },
    });
};

export const deleteKnowledgeBaseItem = (agentId: string, kbItemId: string, authToken: string) => {
    return axiosInstance.delete(`${endpoint.AIAGENT_LIST}/${agentId}/knowledge-base/${kbItemId}`, {
        headers: {
            'x-access-token': authToken,
        },
    });
};

export const getAIAgentDetails = (id: string, authToken: string) => {
    return axiosInstance.get(`${endpoint.AIAGENT_LIST}/${id}`, {
        headers: {
            'x-access-token': authToken,
        },
    }).then(res => res.data.data);
};

export const getTokenUsage = (agentId: string, options: any, authToken: string) => {
    return axiosInstance.get(`${endpoint.AIAGENT_LIST}/${agentId}/token-usage`, {
        params: {
            page: options.page,
            limit: options.limit
        },
        headers: {
            'x-access-token': authToken,
        },
    });
};

export const createAIAssistant = (payload: CreateAIAssistantPayload) => {
    const formData = new FormData();
    formData.append('name', payload.name);
    formData.append('provider', payload.provider);
    formData.append('ai_model', payload.ai_model);
    formData.append('instructions', payload.instructions);
    formData.append('fallback_response', payload.fallback_response);
    formData.append('knowledgeBaseItems', typeof payload.knowledgeBaseItems === 'string' ? payload.knowledgeBaseItems : JSON.stringify(payload.knowledgeBaseItems));
    formData.append('humanize_response', payload.humanize_response ? 'true' : 'false');
    formData.append('typing_speed', payload.typing_speed ? payload.typing_speed.toString() : '');
    if (payload.files && Array.isArray(payload.files)) {
        payload.files.forEach(file => {
            formData.append('files[]', file);
        });
    }
    return axiosInstance.post(endpoint.AIAGENT_LIST, formData, {
        headers: {
            'x-access-token': payload.authToken,
            'Content-Type': 'multipart/form-data',
        },
    });
}



